module.exports = __webpack_public_path__ + "7c9a63d9a74444aedbb861605f75e39a.svg";